import InfoTag from "pages/echeck/components/InfoTag";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedAmount from "pages/_components/FormattedAmount";
import GridTable from "pages/_components/GridTable/GridTable";
import { bool, number, shape, string } from "prop-types";
import React from "react";
import { statusTagColor, statusTag } from "util/thirdPayment";

const colStyle =  {
    wordBreak : {
        whiteSpace: "normal",
        wordBreak: "break-word"
    }
}   

const   NewLotPaymentItem = ({ paymentItem, isDesktop }) => {
    let quantity = paymentItem.creditAmountQuantity;

    if (typeof paymentItem.creditAmountQuantity === "string" || paymentItem.creditAmountQuantity instanceof String) {
        quantity = parseFloat(paymentItem.creditAmountQuantity.replace(",", "."));
    }

    return (
        <>
            <GridTable.Data columnStart={1} rowStart={1}>
                 <div style={colStyle.wordBreak}>
                    {paymentItem?.transactionNumber || "-"}
                </div>
            </GridTable.Data>
            <GridTable.Data columnStart={2} rowStart={1}>
                  <div style={colStyle.wordBreak}>
                    {paymentItem.cbu}
                  </div>
            </GridTable.Data>
            <GridTable.Data columnStart={3} rowStart={1}>
                <CustomText text={`${paymentItem.productType}`} textType="TEXT" />
            </GridTable.Data>
            <GridTable.Data columnStart={4} rowStart={1}>
                <CustomText text={paymentItem.cuit} textType="TEXT" className="ellipsis" />
            </GridTable.Data>
            <GridTable.Data columnStart={5} rowStart={1}>
                <FormattedAmount
                    quantity={quantity}
                    currency={paymentItem.currency}
                    showAbbreviature={false}
                    className="font-bold"
                />
            </GridTable.Data>
            <GridTable.Data columnStart={6} rowStart={1}>
                <CustomText text={paymentItem.voucher} textType="TEXT" />
            </GridTable.Data>
            <GridTable.Data columnStart={7} rowStart={1}>
                <CustomText text={paymentItem.motivo} textType="TEXT" />
            </GridTable.Data>

            {paymentItem?.status && (
                <GridTable.Data
                    className="tags-double"
                    columnStart={isDesktop ? 8 : 2}
                    rowStart={1}
                    rowWidth={1}
                    alignX={isDesktop ? "center" : "end"}
                    alignY="center">
                    {paymentItem?.status === "PROCESSED_WITH_ERROR" ? (
                        <>
                            <InfoTag
                                type="info"
                                message={statusTag("PROCESSED")}
                                tagBackground={statusTagColor(paymentItem?.status)}
                            />
                            <InfoTag
                                type="info"
                                message={statusTag("WITH_ERROR")}
                                tagBackground={statusTagColor(paymentItem?.status)}
                            />
                        </>
                    ) : (
                        <InfoTag
                            type="info"
                            message={statusTag(paymentItem?.status)}
                            tagBackground={statusTagColor(paymentItem?.status)}
                        />
                    )}
                </GridTable.Data>
            )}
        </>
    );
};

NewLotPaymentItem.propTypes = {
    paymentItem: shape({
        account: string,
        cbu: string,
        cuit: string,
        creditAmountQuantity: string,
        voucher: string,
        motivo: string,
        referenc: string,
        lineNumber: number,
    }).isRequired,
    isDesktop: bool.isRequired,
};

export default NewLotPaymentItem;
